import React, { useContext, useState, useEffect, useRef } from 'react'
import AuthContext from '../../context/AuthContext'
import { Link, NavLink } from 'react-router-dom'
import { useHistory, useLocation } from 'react-router-dom'
import Highlighter from 'react-highlight-words';
import { CSVLink } from "react-csv"
import { handleDeNorm, normalizePhone, deNormalizePhone, handleNorm } from '../../utils/functions/tools/normalizePhone';
import ClientNav from '../../components/clientNav';
import { getClient } from '../../utils/functions/api/getClient';
import { getProject } from '../../utils/functions/api/projects/getProject';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const ProjectProfile = ({ match }) => {


  useEffect(() => {

    document.title = "Project Profile | WillowBMS"
  },)

  return (
    <></>
  )
}

export default ProjectProfile